export const scWalletSynthetixPerpV2 = [
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'market', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'amt', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'getId', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'setId', type: 'uint256' }
		],
		name: 'LogAddMargin',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [{ indexed: true, internalType: 'address', name: 'market', type: 'address' }],
		name: 'LogCancel',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'market', type: 'address' },
			{ indexed: false, internalType: 'int256', name: 'sizeDelta', type: 'int256' },
			{ indexed: false, internalType: 'uint256', name: 'slippage', type: 'uint256' }
		],
		name: 'LogClose',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [{ indexed: true, internalType: 'address', name: 'market', type: 'address' }],
		name: 'LogExecute',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'market', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'longSize', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'slippage', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'getId', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'setId', type: 'uint256' }
		],
		name: 'LogLong',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'market', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'amt', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'getId', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'setId', type: 'uint256' }
		],
		name: 'LogRemoveMargin',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'market', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'shortSize', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'slippage', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'getId', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'setId', type: 'uint256' }
		],
		name: 'LogShort',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'market', type: 'address' },
			{ indexed: false, internalType: 'int256', name: 'sizeDelta', type: 'int256' },
			{ indexed: false, internalType: 'uint256', name: 'slippage', type: 'uint256' }
		],
		name: 'LogTrade',
		type: 'event'
	},
	{ anonymous: false, inputs: [], name: 'LogUpdateKeeperFee', type: 'event' },
	{
		inputs: [],
		name: 'WAD',
		outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'address', name: 'market', type: 'address' },
			{ internalType: 'uint256', name: 'amt', type: 'uint256' },
			{ internalType: 'uint256', name: 'getId', type: 'uint256' },
			{ internalType: 'uint256', name: 'setId', type: 'uint256' }
		],
		name: 'addMargin',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	},
	{
		inputs: [{ internalType: 'address', name: 'market', type: 'address' }],
		name: 'cancelOrder',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'address', name: 'market', type: 'address' },
			{ internalType: 'uint256', name: 'slippage', type: 'uint256' }
		],
		name: 'closeTrade',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	},
	{
		inputs: [],
		name: 'dynamicGas',
		outputs: [{ internalType: 'contract IDynamicGasFees', name: '', type: 'address' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'address', name: 'market', type: 'address' },
			{ internalType: 'bytes[]', name: 'priceUpdateData', type: 'bytes[]' }
		],
		name: 'execute',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'address', name: 'market', type: 'address' },
			{ internalType: 'uint256', name: 'longSize', type: 'uint256' },
			{ internalType: 'uint256', name: 'slippage', type: 'uint256' },
			{ internalType: 'uint256', name: 'getId', type: 'uint256' },
			{ internalType: 'uint256', name: 'setId', type: 'uint256' }
		],
		name: 'long',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	},
	{
		inputs: [],
		name: 'name',
		outputs: [{ internalType: 'string', name: '', type: 'string' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'address', name: 'market', type: 'address' },
			{ internalType: 'uint256', name: 'amt', type: 'uint256' },
			{ internalType: 'uint256', name: 'getId', type: 'uint256' },
			{ internalType: 'uint256', name: 'setId', type: 'uint256' }
		],
		name: 'removeMargin',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'address', name: 'market', type: 'address' },
			{ internalType: 'uint256', name: 'shortSize', type: 'uint256' },
			{ internalType: 'uint256', name: 'slippage', type: 'uint256' },
			{ internalType: 'uint256', name: 'getId', type: 'uint256' },
			{ internalType: 'uint256', name: 'setId', type: 'uint256' }
		],
		name: 'short',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	},
	{
		inputs: [],
		name: 'susd',
		outputs: [{ internalType: 'contract ERC20', name: '', type: 'address' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'address', name: 'market', type: 'address' },
			{ internalType: 'int256', name: 'sizeDelta', type: 'int256' },
			{ internalType: 'uint256', name: 'slippage', type: 'uint256' }
		],
		name: 'trade',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	},
	{
		inputs: [],
		name: 'updateKeeperFee',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	}
];
